import { render } from "./shareEvent.vue?vue&type=template&id=3b4390fd&scoped=true"
import script from "./shareEvent.vue?vue&type=script&lang=js"
export * from "./shareEvent.vue?vue&type=script&lang=js"

import "./shareEvent.vue?vue&type=style&index=0&id=3b4390fd&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4390fd"]])

export default __exports__